import GemMeterBaseRule from '../GemMeterBaseRule';
import { WEAK_CALL_TO_ACTION } from '../../../constants/rulesConstants';

export default class ButtonTextLengthRuble extends GemMeterBaseRule {
  static ruleId = WEAK_CALL_TO_ACTION.id;

  static validate(selector: string) {
    const element = GemMeterBaseRule.getElement(selector);
    if (!element) {
      return true;
    }

    return element.textContent!.trim().length <= 24;
  }
}
